import { DISEASE } from './disease';

export const PFIZER = 'pfizer';
export const LEUKEMIARF = 'leukemiarf';
export const CIGNA = 'cigna';

export const DISEASES_BY_PROVIDER = {
  [LEUKEMIARF]: [
    DISEASE.AML,
    DISEASE.CLL,
    DISEASE.MDS,
    DISEASE.CML,
  ],
};

export const OTHER_CANCER_FOR_PROVIDERS = [
  CIGNA,
];
